import React from 'react';
import classNames from 'classnames';
import * as styles from '../../DataExtractionTemplate.module.scss';
import InterventionsMainContent from './InterventionsMainContent';
import { useInterventionWizardContext } from './InterventionWizardProvider';

type Props = {
  hasExtractedData?: boolean;
  useSuggestions: boolean;
};

const InterventionsPanel = ({
  hasExtractedData = false,
  useSuggestions,
}: Props) => {
  const wizard = useInterventionWizardContext();
  const sectionClassnames = classNames({
    [styles.Panel]: true,
    [styles.WithinAccordion]: true,
  });

  return (
    <section id="interventions" className={sectionClassnames}>
      <div className={styles.details}>
        {!wizard.isWizardOpen && (
          <InterventionsMainContent
            hasExtractedData={hasExtractedData}
            useSuggestions={useSuggestions}
          />
        )}
      </div>
    </section>
  );
};

export default InterventionsPanel;
